import React from 'react'

import useScrollbarWidth from '../../hooks/scrollbar-width'

interface Props {
	element?: HTMLElement
	children: (scrollbarWidth: number | undefined) => React.ReactElement
}

const ScrollbarListener: React.FC<Props> = ({ children, element }) => {
	const scrollbarWidth = useScrollbarWidth(element)

	return children(scrollbarWidth)
}

export const withScrollbarListener = <Props extends Record<string, never>>(
	Component: React.ComponentType<Props & { scrollbarWidth: number | undefined }>,
	element?: HTMLElement,
): React.FC<Props> => {
	const WithScrollbarWidth = (props: Props) => (
		<ScrollbarListener element={element}>
			{scrollbarWidth => <Component {...props} scrollbarWidth={scrollbarWidth} />}
		</ScrollbarListener>
	)

	return WithScrollbarWidth
}

export default ScrollbarListener
